document.addEventListener("DOMContentLoaded", () => {

    let callback = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
            block = entry.target;
            let number = block.dataset.number;
            let numberspan = block.querySelector(".countnum").id;
        
            counter(numberspan, 0, number, 4, 1); 
            observer.unobserve(entry.target); 
            }
        });
    };

    let options = {
        root: null, 
        rootMargin: "0px",
        threshold: 0, 
    };
                
  let observer = new IntersectionObserver(callback, options);
  const blocks = document.querySelectorAll("#donation-multiplier");

  blocks.forEach((div) => {
    observer.observe(div);
  });

});
   
// Counter function
function counter(id, start, end, durationInSeconds, decimalPlaces = 0) {
    let obj = document.getElementById(id),
      current = start,
      range = end - start,
      startTime = null,
      decimalFactor = Math.pow(10, decimalPlaces);

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function animate(timestamp) {
      if (!startTime) startTime = timestamp;

      const progress = Math.min(1, (timestamp - startTime) / (durationInSeconds * 1000));
      const easedProgress = easeOutCubic(progress);

      current = start + range * easedProgress;
      textContent = (Math.round(current * decimalFactor) / decimalFactor).toFixed(decimalPlaces);
      obj.textContent = textContent.replace(/\./g, ",");
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    }

    requestAnimationFrame(animate);
}
